import { TableWithPagination } from "shared/Components/tableWithPagination/index.js";
import { LeftHalfArrow, downloadWhite } from "helper/icons";
import { globalClasses } from "helper/globalClasses";
import { globalVariables } from "helper/globalVariables";
import { useMediaQuery } from "react-responsive";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";
import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Button } from "shared/Components/button";
import { getRegisteredDogsTrialByTrialCalendarQuery } from "redux/features/hostSlice/trailCalendar/dogsTrialCalendarGql";
import { TextInput } from "shared/Components/textInput";
import { client } from "helper/apolloConfig";
import _debounce from "lodash/debounce";
import { generateEntries } from "redux/features/trialCalendar/trialCalendarGql";
import PageInfo from "shared/Components/pageInfo";
const { paginatedDataCls } = globalClasses;

const headData = [
  globalVariables.element,
  globalVariables.memberName,
  globalVariables.dogName,
  globalVariables.breed,
  globalVariables.division,
];

const TrialRegisterDogsEntries = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const trial = location.state;
  const isTabletMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const [generateFileLoading, setGenerateFileLoading] = useState(false);
  const [getData, { loading, error, data }] = useLazyQuery(
    getRegisteredDogsTrialByTrialCalendarQuery
  );
  const resultData = data?.getRegisteredDogsTrialByTrialCalendar;
  const trials = resultData?.data || [];
  const handlePaginationData = ({
    trialCalendarId = id,
    page = 1,
    size = 10,
    search,
  }) => {
    getData({
      variables: {
        trialCalendarId: +trialCalendarId,
        pageNumber: page,
        pageSize: size,
        search,
      },
    });
  };

  useEffect(() => {
    if (id) {
      handlePaginationData({
        trialCalendarId: id,
      });
    }
  }, [id]);

  const renderTableBody = () =>
    trials.map((trial, index) => (
      <tr className="cursor-default" key={trial.id}>
        <td className={paginatedDataCls(index)}>{trial?.elements}</td>
        <td className={paginatedDataCls(index)}>{trial?.memberName}</td>
        <td className={paginatedDataCls(index)}>{trial?.dog}</td>
        <td className={paginatedDataCls(index)}>{trial?.breed}</td>
        <td className={paginatedDataCls(index)}>{trial?.division}</td>
      </tr>
    ));

  const debouncedHandleSearch = _debounce((value) => {
    handlePaginationData({ search: value });
  }, 1000); // Adjust the debounce delay as needed

  const onChangeSearchName = (event) => {
    const value = event?.target?.value;
    if (value) {
      debouncedHandleSearch(value);
    } else {
      handlePaginationData({});
    }
  };

  const trialDate = moment.utc(trial?.trialDate).format("MMM DD, YYYY");

  const entriesFor = `Entries for ${trial?.trialName}, ${trialDate}`;

  const handleDownloadIconClick = async () => {
    setGenerateFileLoading(true);
    try {
      const result = await client.query({
        query: generateEntries,
        variables: {
          trialCalendarId: +id,
        },
      });
      const data = result?.data?.generateEntriesPdf;
      window.open(data?.url, "_blank");
      setGenerateFileLoading(false);
      return data;
    } catch (error) {
      setGenerateFileLoading(false);
      return {};
    }
  };
  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10 overflow-x-hidden">
      <PageInfo
        title={trial?.trialName}
        onClick={() => navigate(-1)}
      >
        {trials?.length > 0 && (
          <div>
            <Button
              width={"w-32"}
              label={"Download"}
              icon={downloadWhite}
              onClick={handleDownloadIconClick}
              disabled={generateFileLoading}
            />
          </div>
        )}
      </PageInfo>
      <div className="w-full overflow-x-auto">
        <TableWithPagination
          title={entriesFor}
          headData={headData}
          tableHeight={`${isTabletMobile ? "h-[85vh]" : "h-[550px]"}`}
          tableBody={renderTableBody()}
          itemsPerPage={10}
          totalPage={resultData?.totalPages}
          handlePageChange={(page) => handlePaginationData({ page })}
          loading={loading}
          error={error}
          headerComponent={
            <TextInput
              placeholder={globalVariables.search}
              onChange={onChangeSearchName}
              label={globalVariables.search}
           />
          }
        />
      </div>
    </div>
  );
};

export default TrialRegisterDogsEntries;
